import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	data: [],
	isLoaded: false,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR PACKET STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };
			// ****************** FETCH PACKET PRODUCTS ******************
			case types.FETCH_PACKET_PRODUCTS_LOADING:
				draft.isLoaded = false;
				draft.error = false;
				return;

			case types.FETCH_PACKET_PRODUCTS_SUCCESS:
				draft.data = action.payload.data;
				draft.isLoaded = true;
				return;

			case types.FETCH_PACKET_PRODUCTS_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
